import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export const isUnauthorized = (error) => error?.response?.status === 401;

export const getErrorMessage = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  
  // Handle Pydantic validation errors (array of error objects)
  if (Array.isArray(detail) && detail.length > 0) {
    // Extract readable messages from validation errors
    return detail.map(err => err.msg || JSON.stringify(err)).join('. ');
  }
  
  // Handle string error messages
  if (typeof detail === 'string') {
    return detail;
  }
  
  // Fallback
  return fallback;
};
